// extracted by mini-css-extract-plugin
export default {"sideBarItem":"CustomMenu_sideBarItem__OSP5n","centerImg":"CustomMenu_centerImg__jeLOV"};